import DonationTextField from "components/forms/DonationTextField/DonationTextField";
// import * as AuthServiceApi from 'apis/AuthServiceApi';
import React, { useState } from "react";
// import { useDispatch } from "react-redux";
// import { getUserByUserId } from 'apis/UserServiceApi'
import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import Axios from 'axios';
import BenevvSubmitField from "components/forms/BenevvSubmitField/BenevvSubmitField";
import DonationCheckbox from "components/forms/DonationCheckbox/DonationCheckbox";
import { useDispatch } from 'react-redux';
import { useLocation } from "react-router-dom";
import DonationDetails from "../DonationDetails/DonationDetails";
import MobileDonationDetails from "../MobileDonationDetails/MobileDonationDetails";
import {
  DonationFooter,
  DonationFormColLeft,
  DonationFormContainer,
  DonationFormContentWrapper,
  DonationFormH2,
  DonationFormRow,
  DonationFormWrapper,
  PaymentElementWrapper,
} from "./DonationForm.styles";
import DonationProcessBar from "./DonationProcessBar/DonationProcessBar";
// import * as DonorServiceApi from '../DonorServiceApi'
import { updateShowError } from "store/ui/errorPopupScreen/errorPopupScreen.slice";
import { updateShowThankYou } from "store/ui/thankYouScreen/thankYouScreen.slice";
import { CampaignInfo, User } from "types";

interface DonationFormProps {
  userInfo: User;
  amount: string;
  campaignInfo: CampaignInfo;
  eventInfo?: EventInfo;
  isMobile?: boolean;
}

function DonationForm(props: DonationFormProps) {
  const { userInfo, amount, campaignInfo, eventInfo, isMobile } = props;
  // const [key, setKey] = useState('');
  const [fullName, setFullName] = useState(userInfo.name);
  const [email, setEmail] = useState(userInfo.email);
  const [phoneNumber, setPhoneNumber] = useState(userInfo.phone_number);
  const [editProfileInfo, setEditProfileInfo] = useState(false);
  const [anonymous, setAnonymous] = useState(false);
  const [hideAmount, setHideAmount] = useState(false);
  const elements = useElements();
  const stripe = useStripe();
  const dispatch = useDispatch();

  const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  const params = useQuery();

  let key = '';
  let donorId: any = [];
  interface donorResponse {
    id: string,
    message: string
  }

  const app = Axios.create({
    baseURL: process.env.REACT_APP_API_URL
  })

  app.post('/auth/securityHole', {
    userId: params.get("userId")
  }).then(function (response) {
    // console.log(response.data.accessToken);
    key = (response.data.accessToken);
    // console.log('---------------');
    // console.log("Original" + key);
  }).catch(function (error) {
    console.log(error);
  });

  app.interceptors.request.use(
    async (config: any) => {
      config.headers.Authorization = 'Bearer ' + key;
      return config
    })

  const handleProfileInfo = (target: HTMLInputElement) => {
    target.checked ? setEditProfileInfo(true) : setEditProfileInfo(false);
  }

  const handleDonateAnon = (target: HTMLInputElement) => {
    target.checked ? setAnonymous(true) : setAnonymous(false);
  }

  const handleHideAmount = (target: HTMLInputElement) => {
    target.checked ? setHideAmount(true) : setHideAmount(false);
  }

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!stripe || !elements) return;

    try {
      const response = await app.post('/donor/insertDocument', {
        user_id: params.get("userId"),
        campaign_short: params.get("campaignShort"),
        action_id: params.get("activityId"),
        action_type: 'donation',
        amount: params.get("amount"),
        anon: anonymous ? 1 : 0,
        display_donation: hideAmount ? 0 : 1,
      });

      const donorId = response.data.id;

      await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: `http://localhost:3000/congratulations?donorId=${donorId}&userId=${params.get("userId")}&amount=${params.get("amount")}${eventInfo?.activity?.activity_title ? `&eventTitle=${eventInfo?.activity?.activity_title}` : ""}`,
        },
      });

    } catch (error: any) {
      console.error(error);
      dispatch(updateShowError({
        showErrorPopup: true,
        errorMessage: error.message || 'Unknown error'
      }));
    }
  };

  return (
    <DonationFormContainer>
      <DonationFormWrapper>

        {!isMobile &&
          <DonationProcessBar />
        }

        <form action={"#"} onSubmit={onSubmit}>
          <DonationFormContentWrapper>
            {isMobile &&
              <MobileDonationDetails amountDollars={amount.substring(0, amount.length - 3)} amountCents={amount.slice(-2)} campaignInfo={campaignInfo} eventInfo={eventInfo} />
            }

            <DonationFormRow>
              <DonationFormColLeft>
                <DonationFormH2>Profile</DonationFormH2>
                <DonationCheckbox htmlFor="editProfileInfo" labelText="Change profile information for this donation?" onChangeMethod={handleProfileInfo} />

                {editProfileInfo && <>
                  <DonationTextField htmlFor={'fullName'} labelText={'Name'} placeholder={'Full name'}
                    required={true} setTextField={setFullName} value={fullName} />
                  <DonationFormRow>
                    <DonationTextField htmlFor={'email'} labelText={'Email'} placeholder={'EmailAddress@example.com'}
                      required={true} email={false} setTextField={setEmail} value={email} />
                    <DonationTextField htmlFor={'phoneNumber'} labelText={'Rep Phone'} placeholder={'+1 (999) 999-9999'}
                      required={true} tel={true} setTextField={setPhoneNumber} value={phoneNumber} />
                  </DonationFormRow>
                </>}

                <DonationFormH2>Payment Information</DonationFormH2>
                <PaymentElementWrapper>
                  <PaymentElement />
                </PaymentElementWrapper>
              </DonationFormColLeft>

              {!isMobile &&
                <DonationDetails amountDollars={amount.substring(0, amount.length - 3)} amountCents={amount.slice(-2)} campaignInfo={campaignInfo} eventInfo={eventInfo} />
              }
            </DonationFormRow>

            <DonationFooter>
              <DonationCheckbox htmlFor="anonymity" labelText="I want to donate anonymously" onChangeMethod={handleDonateAnon} />
              <DonationCheckbox htmlFor="hideAmount" labelText="I want to hide the amount I donate" onChangeMethod={handleHideAmount} />

              <BenevvSubmitField value={'Donate Now'} />
            </DonationFooter>
          </DonationFormContentWrapper>
        </form>
      </DonationFormWrapper>
    </DonationFormContainer>
  );
};

export default DonationForm;
